/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * PKCE token request response interface.
 *
 * Represents the response received from a PKCE token request.
 */
export interface PkceTokenResponseInterface {
    access_token: string;
    refresh_token: string;
    expires_in: number;
    token_type: string;
}

/**
 * PKCE token request interface.
 *
 * Represents the request required to initiate a PKCE token request.
 */
export interface PkceTokenRequestInterface {
    grant_type: string;
    code: string;
    code_verifier: string;
    client_id: string;
    redirect_uri: string;
    [key: string]: string;
}

/**
 * PKCE token request class.
 *
 * Concrete implementation of the PkceRefreshRequestInterface.
 */
export class PkceTokenRequest implements PkceTokenRequestInterface {
    // tslint:disable-next-line:variable-name
    public readonly grant_type: string = 'authorization_code';
    [key: string]: string;

    /**
     * Constructor.
     *
     * @param {string} code
     * @param {string} code_verifier
     * @param {string} client_id
     * @param {string} redirect_uri
     */
    // tslint:disable:variable-name
    constructor(
        public code: string,
        public code_verifier: string,
        public client_id: string,
        public redirect_uri: string,
    ) {
        // auto-wired setters
    }
}

/**
 * PKCE token refresh request interface.
 *
 * Represents the request required to initiate a PKCE token refresh request.
 */
export interface PkceRefreshRequestInterface {
    grant_type: string;
    refresh_token: string;
    client_id: string;
    [key: string]: string;
}

/**
 * PKCE token refresh request interface.
 *
 * Concrete implementation of the PkceRefreshRequestInterface.
 */
export class PkceRefreshRequest implements PkceRefreshRequestInterface {
    // tslint:disable-next-line:variable-name
    public readonly grant_type: string = 'refresh_token';
    [key: string]: string;

    /**
     * Constructor.
     *
     * @param {string} refresh_token
     * @param {string} client_id
     */
    // tslint:disable:variable-name
    constructor(public refresh_token: string, public client_id: string) {
        // auto-wired setters
    }
}
